export const mvcTemplateText = {
    ru: {
        yes: 'Да',
        no: 'Нет',
        total: 'Всего'
    },
    en: {
        yes: 'Yes',
        no: 'No',
        total: 'Total'
    },
    th: {
        yes: 'ใช่',
        no: 'ไม่',
        total: 'ทั้งหมด'
    },
    tr: {
        yes: 'Evet',
        no: 'Hayır',
        total: 'Toplam'
    }
};
